/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Clock1Inputs */

const vi_sitesettings_icon_clock1 = /** @type {(inputs: Sitesettings_Icon_Clock1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng hồ`)
};

/**

* @param {Sitesettings_Icon_Clock1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_clock1 = /** @type {((inputs?: Sitesettings_Icon_Clock1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Clock1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_clock1(inputs)
});
export { sitesettings_icon_clock1 as "siteSettings_icon_clock" }